<template>
  <div>
    <div class="min-vh">
      <CRow class="no-gutters px-3 px-sm-0">
        <b-col sm="6" class="text-center text-sm-left mb-3 mb-sm-0">
          <h1 class="mr-sm-4 header-main text-uppercase">ข้อมูล USER ID</h1>
        </b-col>
      </CRow>

      <div class="mt-3 bg-white-border pt-1 px-3 pb-3">
        <b-row v-if="isLoadingData">
          <b-col class="px-4 px-sm-5 py-4 vh-100">
            <img src="/img/loading.svg" class="loading" alt="loading" />
          </b-col>
        </b-row>
        <div v-if="!isLoadingData">
          <b-row class="my-2">
            <b-col class="d-flex justify-content-end">
              <div v-if="id !== '0'">
                Register Date/Time
                {{ formatDate(form.createdTime) }}
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6">
              <InputText
                textFloat="First Name"
                placeholder="First Name"
                type="text"
                name="firstname"
                isRequired
                v-model="form.firstname"
                :isValidate="$v.form.firstname.$error"
                :v="$v.form.firstname"
              />
            </b-col>
            <b-col md="6">
              <InputText
                textFloat="Last Name"
                placeholder="Last Name"
                type="text"
                name="lastname"
                isRequired
                v-model="form.lastname"
                :isValidate="$v.form.lastname.$error"
                :v="$v.form.lastname"
              />
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6">
              <InputText
                textFloat="Employee Id"
                placeholder="Employee Id"
                type="text"
                name="employeeId"
                v-model="form.employeeId"
              />
            </b-col>

            <b-col
              md="6"
              v-if="
                brandDetail.autoAssignAgent ===
                autoAssignAgent.ConversationWorkLoad
              "
            >
              <b-row>
                <b-col md="7">
                  <InputText
                    textFloat="Maximum Conversation"
                    placeholder="Maximum Conversation"
                    type="number"
                    name="maximumConversation"
                    v-model="form.maximumConversation"
                  />
                </b-col>
                <b-col md="5">
                  <label class="font-weight-bold main-label">
                    Conversation Workload
                  </label>
                  <div>
                    <toggle-button
                      class="mt-1 mr-1"
                      v-model="form.conversationWorkloadEnable"
                      :color="{
                        checked: '#27BDA7',
                        unchecked: '#B0B0B0',
                      }"
                    />
                    <span class="ml-2 f-size-18 text-header">
                      {{ form.conversationWorkloadEnable ? "Active" : "Inactive" }}
                    </span>
                  </div>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6">
              <InputText
                textFloat="Username"
                placeholder="Username"
                type="text"
                name="username"
                class="username"
                :readonly="true"
                isRequired
                v-model="form.username"
                :isValidate="$v.form.username.$error"
                :v="$v.form.username"
                @onFocus="$event.target.readOnly = false"
              />
            </b-col>
            <b-col md="6" v-if="!isDisplayPassword">
              <InputText
                textFloat="Password"
                placeholder="Password"
                type="password"
                name="password"
                isRequired
                :disabled="id !== '0'"
                v-model="form.password"
                :isValidate="$v.form.password.$error"
                :v="$v.form.password"
                class="mb-1"
              />
            </b-col>
            <b-col md="6" v-else>
              <InputText
                textFloat="Password"
                placeholder="Password"
                type="password"
                name="password"
                isRequired
                :disabled="true"
                v-model="displayPassword"
                class="mb-1"
              />
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6">
              <InputSelect
                title="Role"
                v-model="form.roleId"
                @onDataChange="handleChangeType"
                name="role"
                isRequired
                :options="roleList"
                valueField="id"
                textField="name"
              />
            </b-col>
            <b-col md="6">
              <span class="text-warning-message">
                (รหัสผ่านจำเป็นจะต้องมีตัวเลขและตัวอักษรรวมกันอย่างน้อย 8 ตัว
                เพื่อความปลอดภัย)
              </span>
              <button
                v-if="id !== '0' && isDisplayPassword"
                type="button"
                @click="$refs.modalResetPassword.show()"
                class="btn btn-reset-password text-uppercase mb-2 mt-1"
              >
                Reset Password
              </button>
            </b-col>
          </b-row>
          <b-row class="mt-1">
            <b-col>
              <label class="font-weight-bold main-label">
                สถานะการแสดงผล
                <span class="text-danger">*</span>
              </label>
              <div>
                <toggle-button
                  class="mt-1 mr-1"
                  v-model="form.active"
                  :color="{
                    checked: '#27BDA7',
                    unchecked: '#B0B0B0',
                  }"
                />
                <span class="ml-2 f-size-18 text-header">
                  {{ form.active ? "Active" : "Inactive" }}
                </span>
              </div>
            </b-col>
          </b-row>
          <hr />
          <div class="w-100" v-if="id != 0">
            <div class="d-flex p-sm-0">
              <b-row class="no-gutters w-100 align-items-center">
                <b-col cols="12" md="6" class="my-1">
                  <label class="mb-0 header-main d-inline"> Customers </label>
                </b-col>
                <b-col cols="12" md="6" class="my-1">
                  <div class="d-flex justify-content-end">
                    <b-input-group class="mr-3">
                      <b-form-input
                        v-model="filter.search"
                        placeholder="Search Name"
                        @keydown.enter="handleSearch"
                      />
                      <b-input-group-append>
                        <b-button @click="search" class="search-button">
                          <font-awesome-icon icon="search" />
                        </b-button>
                      </b-input-group-append>
                    </b-input-group>
                    <b-dropdown
                      id="dropdown-filter"
                      variant="outline"
                      right
                      ref="dropdownfilter"
                      class="filter-custom mr-2 text-nowrap"
                    >
                      <template v-slot:button-content>
                        <font-awesome-icon icon="filter" class="mr-2" />FILTER
                      </template>
                      <div>
                        <p class="mb-2 dropdown-date-custom-text">Channel</p>
                        <hr class="mt-0 mb-1" />
                        <b-row
                          class="d-flex align-content-center justify-content-center mx-1"
                        >
                          <div class="input-flex-container">
                            <b-form-checkbox-group
                              v-model="filter.channelId"
                              :options="channelList"
                              class="my-2"
                              value-field="id"
                              text-field="name"
                            ></b-form-checkbox-group>
                          </div>
                        </b-row>
                        <b-button
                          class="btn submit-button btn-secondary w-100 mt-2"
                          @click="search()"
                        >
                          <span class="ml-2">Search</span>
                        </b-button>
                      </div>
                    </b-dropdown>
                    <b-button
                      class="btn-main"
                      :disabled="!customerList.length"
                      @click="openModalAssign"
                    >
                      <div class="text-nowrap">
                        <span class="ml-2">CHANGE AGENT</span>
                      </div>
                    </b-button>
                  </div>
                </b-col>
              </b-row>
            </div>
            <div class="mt-3">
              <b-row class="no-gutters px-sm-0">
                <b-col>
                  <b-table
                    class="table-list"
                    striped
                    responsive
                    hover
                    :items="items"
                    :fields="fields"
                    :busy="isBusy"
                    show-empty
                    empty-text="ไม่พบข้อมูล"
                  >
                    <template v-slot:table-busy>
                      <div class="text-center text-black my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong class="ml-2">Loading...</strong>
                      </div>
                    </template>
                    <template v-slot:cell(id)="data">
                      <b-form-checkbox
                        v-model="customerList"
                        :value="data.item.customerGUID"
                      ></b-form-checkbox>
                    </template>
                    <template v-slot:cell(externalId)="data">
                      <div class="d-flex align-items-center mt-1">
                        <div class="img-customer mr-2">
                          <b-img
                            v-if="data.item.imageUrl"
                            :src="data.item.imageUrl"
                            blank-color="#8a93a2"
                            rounded="circle"
                            width="55px"
                            @error="replaceByDefault"
                          />
                          <b-avatar
                            v-else
                            size="55px"
                            class="text-uppercase font-weight-bold"
                            >{{
                              data.item.firstname
                                ? data.item.firstname.substring(0, 1)
                                : ""
                            }}</b-avatar
                          >
                        </div>
                        <div class="d-flex flex-column mt-1">
                          <span>{{ data.item.externalId }} </span>
                          <span>{{ data.item.customerGUID }} </span>
                        </div>
                      </div>
                    </template>
                    <template v-slot:cell(socialTypeId)="data">
                      <img
                        v-if="data.item.socialTypeId"
                        :src="getSocial(data.item.socialTypeId)"
                        width="20px"
                      />
                      <span v-else>-</span>
                    </template>
                  </b-table>
                </b-col>
              </b-row>
              <b-row class="no-gutters px-3 px-sm-0">
                <b-col
                  class="form-inline justify-content-end justify-content-sm-end"
                >
                  <div class="d-sm-flex">
                    <b-pagination
                      v-model="filter.pageNo"
                      :total-rows="rows"
                      :per-page="filter.perPage"
                      class="m-md-0"
                      @change="pagination"
                      align="center"
                    ></b-pagination>
                  </div>
                </b-col>
              </b-row>
            </div>
          </div>
          <b-row class="mt-4">
            <b-col md="6">
              <router-link to="/user">
                <b-button
                  :disabled="isDisable"
                  class="btn-details-set btn-cancel"
                  >CANCEL</b-button
                >
              </router-link>
            </b-col>
            <b-col md="6" class="text-sm-right">
              <button
                type="button"
                @click="checkForm()"
                :disabled="isDisable"
                class="btn btn-main btn-details-set ml-md-2 text-uppercase"
              >
                SAVE
              </button>
            </b-col>
          </b-row>
        </div>
      </div>
    </div>
    <ModalLoading ref="modalLoading" :hasClose="false" />
    <ModalAssign
      ref="ModalAssign"
      :data="customerList"
      :userGUID="id"
      @reloadData="search()"
    />
    <ModalResetPassword
      ref="modalResetPassword"
      :userData="form"
      :setNewPassword="setNewPassword"
    />
  </div>
</template>

<script>
import {
  required,
  integer,
  minLength,
  requiredIf,
  email,
  helpers,
  alphaNum,
} from "vuelidate/lib/validators";

const password = helpers.regex(
  "password",
  /^(?=.*[0-9])(?=.*[a-zA-Z])([a-zA-Z0-9!-_]+)$/
);

const alpha = helpers.regex("alpha", /^[\u0E00-\u0E7Fa-zA-Z' ]*$/);
import defaultImg from "@/assets/images/icons/blank.png";
import InputText from "@/components/inputs/InputText";
import InputSelect from "@/components/inputs/InputSelect";
import ModalLoading from "@/components/modal/alert/ModalLoading";
import ModalResetPassword from "./component/ModalResetPassword.vue";
import ModalAssign from "./component/ModalAssign.vue";

export default {
  components: {
    InputText,
    InputSelect,
    ModalLoading,
    ModalAssign,
    ModalResetPassword,
  },
  data() {
    return {
      isLoadingData: false,
      isDisable: false,
      id: this.$route.params.id,
      redirecId: 0,
      isEditPassword: false,
      isDisplayPassword: false,
      autoAssignAgent: {
        Manual: 0,
        ConversationWorkLoad: 1,
      },
      displayPassword: "TESTPASSWORD001",
      form: {
        brandId: this.$route.query.brandID,
        roleId: 2,
        userGUID: "",
        username: "",
        firstname: "",
        lastname: "",
        staffId: "",
        password: "",
      },
      customerList: [],
      filter: {
        channelId: [],
        search: "",
        pageNo: 1,
        perPage: 10,
      },
      fields: [
        {
          key: "id",
          label: "",
          class: "w-action",
        },
        {
          key: "externalId",
          label: "ID",
          class: "w-100px",
        },
        // {
        //   key: "socialName",
        //   label: "Social Name",
        //   class: "w-100px",
        // },
        {
          key: "displayname",
          label: "Display Name",
          class: "w-100px",
        },
        {
          key: "socialTypeId",
          label: "Channel",
          class: "w-100px",
        },
      ],
      roleList: [
        {
          id: 2,
          name: "Agent",
        },
        {
          id: 3,
          name: "Super Admin",
        },
        {
          id: 4,
          name: "Team Admin",
        },
      ],
      channelList: [
        {
          id: 1,
          name: "Line",
        },
        {
          id: 2,
          name: "Facebook",
        },
        {
          id: 3,
          name: "Web",
        },
        {
          id: 4,
          name: "X",
        },
        {
          id: 5,
          name: "Channel",
        },
      ],
      rows: 0,
      items: [],
      isBusy: false,
    };
  },
  validations: {
    form: {
      firstname: { required, alpha },
      lastname: { required, alpha },
      username: { required },
      password: {
        required: requiredIf(function () {
          return this.id == 0;
        }),
        password,
        minLength: minLength(8),
      },
    },
  },
  created: async function () {
    await this.getDatas();
    await this.getList();
    await this.getChannel();
  },
  computed: {
    brandDetail() {
      return this.$store.getters.getBrandDetail();
    },
  },
  methods: {
    getChannel: async function () {
      const url = `${this.$baseUrl}/analytics/Filter/Channel`;
      await this.axios.get(url).then(async (data) => {
        if (data.result === 1) {
          this.channelList = data.detail;
        }
      });
    },
    getSocial(id) {
      let index = this.channelList.findIndex((el) => el.id == id);
      if (index != -1) {
        return this.channelList[index].imageUrl;
      }
    },
    isAlphabet: function (evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 65 && charCode < 91) {
        return true;
      } else if (charCode > 96 && charCode < 123) {
        return true;
      } else if (charCode > 160 && charCode < 238) {
        return true;
      } else {
        evt.preventDefault();
      }
      // if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      //   evt.preventDefault();
      // } else {
      //   return true;
      // }
    },
    handleAfterSave() {
      if (this.id == "0") {
        this.$router.push({ path: `/user/details/${this.redirecId}` });
      } else {
        this.getDatas();
      }
    },
    handleChangeType(value) {
      this.form.roleId = value;
    },
    openModalAssign() {
      this.$refs.ModalAssign.show();
    },
    setNewPassword(newPassword) {
      this.form.password = newPassword;
      this.isEditPassword = true;
    },
    replaceByDefault(e) {
      e.target.src = defaultImg;
    },
    cancleHandler() {
      this.$router.push({ name: "USER LIST" });
    },
    pagination(Page) {
      this.filter.pageNo = Page;
      this.getList();
    },
    handleSearch(e) {
      if (e.keyCode === 13) {
        this.filter.pageNo = 1;
        this.getList();
      }
    },
    search() {
      this.filter.pageNo = 1;
      this.$refs.dropdownfilter.hide(false);
      this.getList();
    },
    getList: async function () {
      if (this.id !== "0") {
        this.isBusy = true;
        await this.axios
          .post(
            `${this.$baseUrl}/customer/customer-fix-agent/${this.form.userGUID}`,
            this.filter
          )
          .then((data) => {
            this.isBusy = false;
            if (data.result == 1) {
              this.items = data.detail.data;
              this.rows = data.detail.count;
            }
          });
      }
    },
    getDatas: async function () {
      if (this.id !== "0") {
        this.isLoadingData = true;
        await this.axios
          .get(`${this.$baseUrl}/user/${this.id}`)
          .then((data) => {
            if (data.result == 1) {
              this.form = data.detail;
              this.isDisplayPassword = true;
              this.isLoadingData = false;
            }
          });
      } else {
        this.isEditPassword = true;
      }
    },
    checkForm: async function () {
      this.$v.form.$touch();
      if (this.$v.form.$error) {
        return;
      }

      if (!this.isEditPassword) {
        this.form.password = null;
      }
      this.submit();
    },
    submit: async function () {
      this.isDisable = true;

      this.$refs.modalLoading.show();
      const payload = {
        ...this.form,
        maximumConversation:
          this.form.maximumConversation === ""
            ? null
            : this.form.maximumConversation,
      };
      await this.axios
        .post(`${this.$baseUrl}/user/save`, payload)
        .then((data) => {
          this.$refs.modalLoading.hide();
          if (data.result == 1) {
            this.redirecId = data.detail.userGUID;
            this.$store.commit("UPDATE_GLOBAL_ALERT", {
              isShow: true,
              msg: "สำเร็จ",
            });
            this.isEditPassword = false;
            this.handleAfterSave();
          } else {
            this.$store.commit("UPDATE_GLOBAL_ALERT_ERROR", {
              isShow: true,
              msg: data.message,
            });
          }
          this.isDisable = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.btn-reset-password {
  background-color: #7160c4;
  color: white;
}
::v-deep .input-group-append {
  height: 35px;
}
::v-deep .dropdown-menu-right {
  min-width: 400px;
}
.input-flex-container {
  display: flex;
  flex-direction: row;
  align-items: center;
}

label {
  color: #404040;
  font-size: 16px;
  margin-bottom: 2px;
  font-weight: bold;
}

.submit-button {
  background-color: #5b57a5;
  color: white;
  border-radius: 4px;
}

.text-warning-message {
  color: #bebebe;
  font-size: 11px;
}
</style>
